<template>
  <div>
    <vue-tags-input
      v-model="customerSearch"
      :tags="customersSelected"
      @tags-changed="updateCustomers"
      :autocomplete-items="customers"
      :add-on-blur="false"
      :add-only-from-autocomplete="true"
      :placeholder="$t('tours.headline.companysearch')"
      :max-tags="maxTags"
      class="c-customer-select"
    >
      <div slot="autocomplete-item" slot-scope="props" @click="props.performAdd(props.item)">
        {{ props.item.text }}
        <small>#{{ props.item.id }}</small>
        <template v-if="props.item.risk">
            <small v-if="props.item.risk.is_valid">{{$t('location.risk.risk_number')}}: {{props.item.risk.risk_number}}</small>
            <small v-else class="u-color--warning">{{$t('location.risk.not_valid')}}</small>
        </template>
        <small v-else class="u-color--warning">{{$t('location.risk.no_risk_number')}}</small>

      </div>
      <div slot="tag-center" slot-scope="props">
          {{ props.tag.text }}
          <template v-if="props.tag.risk">{{$t('location.risk.risk_number')}} {{props.tag.risk.risk_number}}</template>
      </div>
    </vue-tags-input>
  </div>
</template>

<script>
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  name: "customerSelect",
  props: {
    selectedCustomers: {
      type: Array,
      default: () => []
    },
    maxTags: {
      type: Number,
      default: 0
    }
  },
  components: {
    VueTagsInput
  },
  data() {
    return {
      customerSearch: "",
      customers: [],
      customersSelected: this.selectedCustomers
    };
  },
  watch: {
    $route: function() {
      this.customersSelected = [];
    },
    customerSearch: "getCustomers"
  },
  methods: {
    getCustomers: function() {
      if (this.customerSearch.length < 2) {
        return;
      }

      let promise = this.$api
        .clearParams()
        .addParam("search", this.customerSearch)
        .get("tours/locations");

      return promise
        .then(response => {
          this.customers = response.data.data.map(a => {
            let text = a.company_name;

            return {
              id: a.id,
              text: text,
              managers: a.managers,
              risk: a.risk
            };
          });
        })
        .catch(error => {
          return [];
        });
    },
    updateCustomers: function(newTags) {
      this.customers = [];
      this.isDisabled = false;
      this.customersSelected = newTags;
      this.$emit("change-customers", newTags);
      let count = newTags.length;
      if (this.maxTags && this.maxTags > 0 && count === this.maxTags) {
        this.isDisabled = true;
      }
    }
  }
};
</script>